import { parseFormattedNumber } from '@views/bankTransactions/routes/BankTransactions/utils/parseFormattedNumber'

export const matchesAmountSearch = (
  amount: number | undefined,
  searchQuery: string,
  parsedNumber: number,
  isNumericSearch: boolean,
): boolean => {
  const compactSearchTerm = searchQuery.trim().replace(/\s/g, '').replace(',', '.')

  // `amount === undefined` (not `!amount`) so a legitimate `0` still matches
  if (!compactSearchTerm || amount === undefined) {
    return false
  }

  const absoluteAmountString = Math.abs(amount).toString()

  if (isNumericSearch) {
    return absoluteAmountString.startsWith(Math.abs(parsedNumber).toString())
  }

  return absoluteAmountString.includes(compactSearchTerm)
}

export const getAmountSearchContext = (searchQuery: string) => {
  const parsedNumber = parseFormattedNumber(searchQuery)

  return {
    isNumericSearch: !Number.isNaN(parsedNumber),
    parsedNumber,
  }
}
